import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const ShowPostDetail = (props) => {
  const [loading, setLoading] = useState(true);
  const [podOdb, setPodOdb] = useState(0);
  const [category, setCategory] = useState("EKONOMICZNA");
  const [name1, setName1] = useState("");
  const [name2, setName2] = useState("");
  const [street, setStreet] = useState("");
  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");
  const [city, setCity] = useState("");
  const [editGuid, setEditGuid] = useState("");
  const [postCode, setPostCode] = useState("");
  const [desc, setDesc] = useState("");
  const [task, setTask] = useState("");

  const fetchBufferListNumNadania = async () => {
    if (props.mode === "send") {
      var body = {
        env: props.numNad,
      };
    } else {
      var body = {
        numNad: props.numNad,
      };
    }

    await fetch(
      props.mode === "send"
        ? "https://apidevkppp.ftpeople.pl/getSendPostListDetail"
        : "https://apidevkppp.ftpeople.pl/getBuforListPostBookNumNad",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        var ax = "";
        if (props.mode === "send") {
          ax = data.przesylka.filter(
            (el) => el.przesylkaFull.attributes.numerNadania === props.numNad2
          )[0].przesylkaFull;
        } else {
          ax = data;
        }

        var name1Q = "";
        var name2Q = "";
        if (ax) {
          try {
            if (ax.adres.attributes.nazwa.split(" ").length > 7) {
              ax.adres.attributes.nazwa.split(" ").map((el, index) => {
                if (index <= 6) {
                  name1Q = name1Q + " " + el;
                } else {
                  name2Q = name2Q + " " + el;
                }
              });
            } else {
              name1Q = ax.adres.attributes.nazwa;
            }
          } catch (err) {}

          setName1(name1Q);
          setName2(name2Q);
          setStreet(ax.adres.attributes.ulica);
          setNum1(ax.adres.attributes.numerDomu);
          setCity(ax.adres.attributes.miejscowosc);
          setPostCode(ax.adres.attributes.kodPocztowy);
          setEditGuid(ax.attributes.guid);
          setCategory(ax.attributes.kategoria);
          setPodOdb(ax.attributes.iloscPotwierdzenOdbioru);
          fetchDesc();
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {});
  };

  const fetchDesc = async () => {
    var body = {
      numNad: props.numNad2,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getDescPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          var descR = data.filter((el) => el.guid === props.numNad2)[0];
          if (descR) {
            setDesc(descR.descA);
          }
        }
        fetchTask();
      })
      .catch((error) => {});
  };

  const fetchTask = async () => {
    var body = {
      numNad: props.numNad2,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTaskNumberPost", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          var descR = data.filter((el) => el.guid === props.numNad2)[0];
          if (descR) {
            setTask(descR.taskId);
          }
        }
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchBufferListNumNadania();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div
        className="mainContainerAddClientContact"
        style={{
          backgroundColor: "white",
          position: "fixed",
          right: "0",
          top: "20  vh",
          width: "80%",
          maxHeight: "80vh",
          overflow: "scroll",
        }}
      >
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <p>
          Numer nadania: {props.mode === "send" ? props.numNad2 : props.numNad}
        </p>
        <p>Odbiorca: {name1}</p>
        <p>Adres:</p>
        <p>
          {street} {num1}
        </p>
        <p>
          {postCode} {city}
        </p>
        <p>Potwierdzenie odbioru: {podOdb === "0" ? "NIE" : "TAK"}</p>
        <p>Rodzaj: {category}</p>
        <p>Opis: {desc}</p>
        <p>Zadanie: {task}</p>
      </div>
    </>
  );
};

export default ShowPostDetail;
